/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const TreeNode = require('../TreeNode');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');
const AICalc = require('../AICalc');

const Q_which_aoe_attack = function (actor, battleState, noAOEAbilitiesCaseNode) {
  const node = new TreeNode(actor, battleState, noAOEAbilitiesCaseNode);

  // branch indexes
  node.ROUNDHOUSE = 'roundhouse';
  node.FUMIGATE = 'fumigate';
  node.LIGHTNING = 'lightning';

  node.branches[node.ROUNDHOUSE] = new UseAbility({
    actor,
    abilityHandle: 'roundhouse',
    altNode: noAOEAbilitiesCaseNode,
  });
  node.branches[node.FUMIGATE] = new UseAbility({
    actor,
    abilityHandle: 'fumigate',
    altNode: noAOEAbilitiesCaseNode,
  });
  node.branches[node.LIGHTNING] = new UseAbility({
    actor,
    abilityHandle: 'lightning',
    altNode: noAOEAbilitiesCaseNode,
  });

  node.query = function (static_target) {
    const _bestTarget = static_target || AICalc.getBestMeleeTarget(actor, battleState);
    if (!_bestTarget) return null;

    const equipped_aoe_abilities = ['roundhouse', 'fumigate', 'lightning'].filter(
      (ability_handle) => {
        if (!BattleCalc.getEquippedAbility(node.actor, ability_handle)) {
          return false;
        }

        // Use generic damage prediction to check if AoE is beneficial
        // Target is the actor for self-centered AoE (roundhouse, fumigate)
        // or _bestTarget for targeted AoE (lightning)
        const target = ['roundhouse', 'fumigate'].includes(ability_handle)
          ? node.actor
          : _bestTarget;
        return AICalc.isAoESafe(
          node.actor,
          ability_handle,
          target,
          node.battleState,
          1.5 // Enemy damage must be 50% more than ally damage
        );
      }
    );
    if (equipped_aoe_abilities.length) {
      const random_ability_handle =
        equipped_aoe_abilities[Math.floor(Math.random() * equipped_aoe_abilities.length)];
      return node.branches[random_ability_handle].query(
        ['fumigate', 'roundhouse'].includes(random_ability_handle) ? node.actor : _bestTarget
      );
    } else {
      // _altnode should be set to Q_state_of_best_target (we go for a single target attack)
      return this.altNode.query(static_target);
    }
  };

  return node;
};
module.exports = Q_which_aoe_attack;
